<template>
  <div class="documents-wrapper" ref="documentsWrapper">
    <!-- Skeleton Loading State -->
    <div class="documents-container" v-if="loading">
      <div class="documents-header skeleton-header">
        <div class="contract-info">
          <div class="skeleton-icon"></div>
          <div class="contract-details">
            <div class="skeleton-text skeleton-label"></div>
            <div class="skeleton-text skeleton-title"></div>
          </div>
        </div>
        <div class="document-summary">
          <div class="summary-item">
            <div class="skeleton-text skeleton-number"></div>
            <div class="skeleton-text skeleton-small"></div>
          </div>
        </div>
      </div>
      <div class="search-section skeleton-search">
        <div class="skeleton-input"></div>
      </div>
      <div class="documents-table-container skeleton-table">
        <div class="skeleton-row" v-for="i in 5" :key="i"></div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="documents-container" v-else>
      <!-- Header -->
      <div class="documents-header">
        <div class="contract-info">
          <div class="contract-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
              ></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
          </div>
          <div class="contract-details">
            <span class="contract-label">Documentos disponibles</span>
            <span class="contract-number"
              >{{ documents.length }} documento{{
                documents.length !== 1 ? "s" : ""
              }}</span
            >
          </div>
        </div>
        <div class="document-summary">
          <div class="summary-item">
            <span class="summary-value">{{ documents.length }}</span>
            <span class="summary-label">Total</span>
          </div>
        </div>
      </div>

      <!-- Search Section -->
      <div class="search-section">
        <div class="search-input-wrapper">
          <svg
            class="search-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.35-4.35"></path>
          </svg>
          <input
            type="text"
            v-model="filterDoc"
            @keyup="searchDoc()"
            placeholder="Buscar por descripción..."
            class="search-input"
          />
          <button
            v-if="filterDoc"
            class="clear-btn"
            @click="
              filterDoc = '';
              searchDoc();
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>

      <!-- Empty State -->
      <div class="empty-state" v-if="documents.length === 0">
        <div class="empty-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            ></path>
            <polyline points="14 2 14 8 20 8"></polyline>
          </svg>
        </div>
        <h3 class="empty-title">No hay documentos</h3>
        <p class="empty-text">No se encontraron documentos disponibles.</p>
      </div>

      <!-- Desktop Table -->
      <div class="documents-table-container" v-if="documents.length > 0">
        <table class="documents-table d-none d-lg-table">
          <thead>
            <tr>
              <th>Descripción</th>
              <th>Fecha</th>
              <th class="text-center">Acción</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(document, index) in pageOfItems" :key="'doc-' + index">
              <td>
                <div class="doc-info">
                  <div class="doc-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                      ></path>
                      <polyline points="14 2 14 8 20 8"></polyline>
                    </svg>
                  </div>
                  <div class="doc-details" v-if="document.type == 'Promesa'">
                    <span class="doc-name">
                      Contrato de Prestación de Servicios
                    </span>
                  </div>
                  <div class="doc-details" v-else>
                    <span class="doc-name" v-if="document.name">{{
                      document.name
                    }}</span>
                    <span class="doc-name" v-else
                      >{{ document.type }} Nº
                      {{
                        isNaN(document.number)
                          ? document.number
                          : new Intl.NumberFormat("es-CL").format(
                              document.number
                            )
                      }}</span
                    >
                    <span class="doc-type">{{ document.type }}</span>
                  </div>
                </div>
              </td>
              <td>
                <span class="doc-date">{{ document.date }}</span>
              </td>
              <td class="text-center">
                <a
                  :href="document.url"
                  target="_blank"
                  download
                  class="download-btn"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="7 10 12 15 17 10"></polyline>
                    <line x1="12" y1="15" x2="12" y2="3"></line>
                  </svg>
                  Descargar
                </a>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Mobile Cards -->
        <div class="documents-cards d-lg-none">
          <div
            class="document-card"
            v-for="(document, index) in pageOfItems"
            :key="'card-' + index"
          >
            <div class="card-header">
              <div class="card-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                  ></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                </svg>
              </div>
              <div class="card-info" v-if="document.type == 'Promesa'">
                <span class="card-name">
                  Contrato de Prestación de Servicios
                </span>
              </div>
              <div class="card-info" v-else>
                <span class="card-name" v-if="document.name">{{
                  document.name
                }}</span>
                <span class="card-name" v-else
                  >{{ document.type }} Nº
                  {{
                    isNaN(document.number)
                      ? document.number
                      : new Intl.NumberFormat("es-CL").format(document.number)
                  }}</span
                >
                <span class="card-type">{{ document.type }}</span>
              </div>
            </div>
            <div class="card-body">
              <div class="card-detail">
                <span class="detail-label">Fecha</span>
                <span class="detail-value">{{ document.date }}</span>
              </div>
            </div>
            <div class="card-footer">
              <a
                :href="document.url"
                target="_blank"
                download
                class="download-btn-mobile"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
                Descargar documento
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Pagination -->
      <div class="documents-footer" v-if="documents.length > 0">
        <div class="page-size-selector">
          <label>Mostrar</label>
          <select
            v-model="pageSize"
            @change="changeSize"
            class="page-size-select"
          >
            <option :value="10">10</option>
            <option :value="20">20</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
          <span>por página</span>
        </div>
        <div class="documents-pagination">
          <pagination
            v-model="page"
            :per-page="pageSize"
            :records="documents.length"
            @paginate="onChangePage"
            :options="paginatorOptions"
          ></pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "documents",
  components: {},
  props: {
    asset_id: null,
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      isFirstLoad: true,
      document_tab_index: 0,
      loading: true,
      theme: "bootstrap4",
      pageOfItems: [],
      Apartment: null,
      documents: [],
      documentsOriginal: [],
      filterDoc: "",
      paginatorOptions: {
        texts: { count: "" },
      },
    };
  },
  beforeMount() {
    this.Apartment = this.$store.getters.getApartmentById(
      parseInt(this.asset_id)
    );
    this.setDocuments();
  },
  methods: {
    setDocuments() {
      this.axios
        .get("contracts/" + this.Apartment.contract_id + "/get_documents")
        .then((result) => {
          this.loading = false;
          this.documents = result.data.documents;
          if (this.customer == "clab") {
            this.documents = result.data.documents.filter(
              (doc) => !["Planta", "Catálogo"].includes(doc.type)
            );
          }
          this.documentsOriginal = this.documents;
          this.pageOfItems = this.documents.slice(
            (this.page - 1) * this.pageSize,
            this.page * this.pageSize
          );
        });
    },
    onChangePage(page) {
      this.pageOfItems = this.documents.slice(
        (page - 1) * this.pageSize,
        page * this.pageSize
      );
      if (this.isFirstLoad) {
        this.isFirstLoad = false;
        return;
      }
      this.$nextTick(() => {
        if (this.$refs.documentsWrapper) {
          this.$refs.documentsWrapper.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    },
    searchDoc() {
      this.documents = this.documentsOriginal.filter((doc) => {
        return doc.name.toLowerCase().includes(this.filterDoc.toLowerCase());
      });
      this.page = 1;
      this.pageOfItems = this.documents.slice(
        (this.page - 1) * this.pageSize,
        this.page * this.pageSize
      );
    },
    changeSize() {
      this.page = 1;
      this.pageOfItems = this.documents.slice(
        (this.page - 1) * this.pageSize,
        this.page * this.pageSize
      );
    },
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
  },
};
</script>

<style scoped>
/* ===== Wrapper ===== */
.documents-wrapper {
  padding: 0;
}

.documents-container {
  max-width: 100%;
}

/* ===== Header ===== */
.documents-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  padding: 20px 24px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.contract-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.contract-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 12px;
  color: var(--color-btn, #3b82f6);
}

.contract-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.contract-label {
  font-size: 0.8125rem;
  color: #6b7280;
  font-weight: 500;
}

.contract-number {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
}

.document-summary {
  display: flex;
  align-items: center;
  gap: 20px;
  background: white;
  padding: 12px 20px;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.summary-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
  gap: 2px;
}

.summary-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--color-btn, #3b82f6);
}

.summary-label {
  font-size: 0.75rem;
  color: #6b7280;
  font-weight: 500;
}

/* ===== Search Section ===== */
.search-section {
  margin-bottom: 20px;
}

.search-input-wrapper {
  display: flex;
  align-items: center;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 0 16px;
  transition: all 0.2s ease;
}

.search-input-wrapper:focus-within {
  border-color: var(--color-btn, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-icon {
  color: #9ca3af;
  flex-shrink: 0;
}

.search-input {
  flex: 1;
  border: none;
  padding: 14px 12px;
  font-size: 0.9375rem;
  background: transparent;
  outline: none;
}

.search-input::placeholder {
  color: #9ca3af;
}

.clear-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  border: none;
  border-radius: 8px;
  padding: 6px;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s ease;
}

.clear-btn:hover {
  background: #e5e7eb;
  color: #374151;
}

/* ===== Empty State ===== */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
}

.empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: #f3f4f6;
  border-radius: 20px;
  color: #9ca3af;
}

.empty-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
}

.empty-text {
  font-size: 0.9375rem;
  color: #6b7280;
  margin: 0;
}

/* ===== Desktop Table ===== */
.documents-table-container {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.documents-table {
  width: 100%;
  border-collapse: collapse;
}

.documents-table thead tr {
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.documents-table th {
  padding: 14px 20px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  text-align: left;
}

.documents-table tbody tr {
  border-bottom: 1px solid #f3f4f6;
  transition: background 0.2s ease;
}

.documents-table tbody tr:last-child {
  border-bottom: none;
}

.documents-table tbody tr:hover {
  background: #f9fafb;
}

.documents-table td {
  padding: 16px 20px;
  vertical-align: middle;
}

.doc-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.doc-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 10px;
  color: var(--color-btn, #3b82f6);
  flex-shrink: 0;
}

.doc-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.doc-name {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1f2937;
}

.doc-type {
  font-size: 0.8125rem;
  color: #6b7280;
}

.doc-date {
  font-size: 0.9375rem;
  color: #4b5563;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--color-btn, #3b82f6);
  color: white;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
}

.download-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  color: white;
  text-decoration: none;
}

/* ===== Mobile Cards ===== */
.documents-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.document-card {
  background: white;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.card-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 10px;
  color: var(--color-btn, #3b82f6);
  flex-shrink: 0;
}

.card-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.card-name {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1f2937;
  word-break: break-word;
}

.card-type {
  font-size: 0.8125rem;
  color: #6b7280;
}

.card-body {
  padding: 12px 0;
  border-top: 1px solid #f3f4f6;
  border-bottom: 1px solid #f3f4f6;
  margin-bottom: 12px;
}

.card-detail {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.detail-label {
  font-size: 0.75rem;
  color: #6b7280;
  font-weight: 500;
}

.detail-value {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1f2937;
}

.card-footer {
  display: flex;
}

.download-btn-mobile {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  background: var(--color-btn, #3b82f6);
  color: white;
  border-radius: 10px;
  font-size: 0.9375rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
}

.download-btn-mobile:hover {
  opacity: 0.9;
  color: white;
  text-decoration: none;
}

/* ===== Footer & Pagination ===== */
.documents-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  flex-wrap: wrap;
  gap: 16px;
}

.page-size-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  color: #6b7280;
}

.page-size-select {
  padding: 8px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: white;
  font-size: 0.875rem;
  color: #374151;
  cursor: pointer;
  outline: none;
}

.page-size-select:focus {
  border-color: var(--color-btn, #3b82f6);
}

.documents-pagination {
  display: flex;
  justify-content: center;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 8px 0;
}

.documents-pagination :deep(.pagination) {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  list-style: none;
  padding: 0;
  margin: 0;
  justify-content: center;
}

.documents-pagination :deep(.page-item) {
  display: inline-block;
}

.documents-pagination :deep(.page-link),
.documents-pagination :deep(a) {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  padding: 0 10px;
  border-radius: 8px;
  color: #4b5563;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
  border: 1px solid #e5e7eb;
  background: #ffffff;
}

.documents-pagination :deep(.page-item.active .page-link),
.documents-pagination :deep(.active a),
.documents-pagination :deep(a.active) {
  background: var(--color-btn, #3b82f6);
  color: white;
  border-color: var(--color-btn, #3b82f6);
}

.documents-pagination :deep(.page-link:hover),
.documents-pagination :deep(a:hover) {
  background: #f3f4f6;
}

.documents-pagination :deep(.VuePagination__count) {
  display: none;
}

/* ===== Skeleton Styles ===== */
@keyframes skeleton-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}

.skeleton-header {
  animation: skeleton-pulse 1.5s ease-in-out infinite;
}

.skeleton-icon {
  width: 48px;
  height: 48px;
  background: #e5e7eb;
  border-radius: 12px;
}

.skeleton-text {
  background: #e5e7eb;
  border-radius: 4px;
}

.skeleton-label {
  width: 120px;
  height: 14px;
}

.skeleton-title {
  width: 80px;
  height: 20px;
  margin-top: 4px;
}

.skeleton-number {
  width: 40px;
  height: 24px;
}

.skeleton-small {
  width: 50px;
  height: 12px;
  margin-top: 4px;
}

.skeleton-search {
  margin-bottom: 20px;
}

.skeleton-input {
  height: 48px;
  background: #e5e7eb;
  border-radius: 12px;
  animation: skeleton-pulse 1.5s ease-in-out infinite;
}

.skeleton-table {
  background: white;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #e5e7eb;
}

.skeleton-row {
  height: 60px;
  background: #f3f4f6;
  border-radius: 8px;
  margin-bottom: 12px;
  animation: skeleton-pulse 1.5s ease-in-out infinite;
}

.skeleton-row:last-child {
  margin-bottom: 0;
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .documents-header {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
    gap: 16px;
  }

  .contract-info {
    justify-content: center;
  }

  .document-summary {
    justify-content: center;
  }

  .documents-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .page-size-selector {
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .documents-header {
    padding: 12px;
    border-radius: 12px;
    margin-bottom: 16px;
  }

  .contract-icon {
    width: 40px;
    height: 40px;
  }

  .contract-icon svg {
    width: 20px;
    height: 20px;
  }

  .contract-number {
    font-size: 1.125rem;
  }

  .document-summary {
    padding: 10px 16px;
  }

  .search-input-wrapper {
    border-radius: 10px;
    padding: 0 12px;
  }

  .search-input {
    padding: 12px 10px;
    font-size: 0.875rem;
  }

  .document-card {
    padding: 14px;
    border-radius: 12px;
  }

  .documents-pagination :deep(.pagination) {
    gap: 3px;
  }

  .documents-pagination :deep(.page-link),
  .documents-pagination :deep(a) {
    min-width: 32px;
    height: 32px;
    padding: 0 8px;
    font-size: 0.8125rem;
    border-radius: 6px;
  }
}
</style>
